<footer class="px-base xl:px-base-desk flex flex-col gap-4 relative text-center pb-4 text-xs {{additionalClasses}}">
    @if (!hideCustomFooter) {
        <p [innerHTML]="text"></p>
    }
    @if (!hideMetaCredits) {
        <p class="flex flex-col gap-2 items-center">
            {{'Layout Design & Web Development' | translate}}<br/>
            <span class="flex gap-3 items-center">
                <a href="https://www.dedanext.it/" title="Vai al sito web di Deda Next">
                    <img src="core/assets/images/logo-dedanext.png" class="max-h-[1.5rem]" alt="Logo Deda Next"/>
                </a>
                @if (showEttLogo) {
                    <a href="https://ettsolutions.com/" title="Vai al sito web di ETT Solutions">
                        <img src="core/assets/images/ett.png" class="max-h-[1.5rem]" alt="Logo ETT Solutions"/>
                    </a>
                }
            </span>
        </p>
    }
</footer>